const DEFAULT_ORIGIN = typeof window !== "undefined" ? window.location.origin : "http://localhost";
const BASE_API_URL = DEFAULT_ORIGIN.replace(/\/+$/, "");
const WS_BASE_URL = BASE_API_URL.replace(/^https:\/\//, "wss://").replace(/^http:\/\//, "ws://");

export const ENDPOINTS = {
  USER: `${BASE_API_URL}/api/v1/users/me`,
  LOGIN: `${BASE_API_URL}/api/v1/auth/login`,
  LOGOUT: `${BASE_API_URL}/api/v1/auth/logout`,
  LOGIN_GOOGLE: `${BASE_API_URL}/api/v1/auth/google-login`,
  LOGIN_GOOGLE_CODE: `${BASE_API_URL}/api/v1/auth/google-code`,
  REFRESH_TOKEN: `${BASE_API_URL}/api/v1/auth/refresh-token`,
  STATISTICS_HISTORY: (userId: string, offset: number, pageSize: number) => `${BASE_API_URL}/api/v1/statistics/${userId}?offset=${offset}&limit=${pageSize}`,
};

export { WS_BASE_URL };
